<form
  class="g-3 needs-validation"
  novalidate
  [formGroup]="formFields"
  (ngSubmit)="onSubmit()"
>
  <!-- Policy period details -->
  <div class="form_sections">
    <h4><u>Period of cover from</u></h4>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group w-100">
          <input
            type="text"
            required
            name="inception_date"
            formControlName="inception_date"
            placeholder="Cover From"
            class="form-control form-control-sm datepicker"
            matInput
            (focus)="coverFromDatepicker.open()"
            [matDatepicker]="coverFromDatepicker"
            [min]="quote_type == 3 ? f.inception_date.value : minInceptionDate"
            [max]="maxInceptionDate"
            (dateChange)="onPolicyStartDateChange($event)"
            [ngClass]="{
              'is-invalid':
                (f.inception_date.touched || submitted) &&
                f.inception_date.errors?.required
            }"
          />
          <mat-datepicker-toggle
            [for]="coverFromDatepicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #coverFromDatepicker></mat-datepicker>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.inception_date.touched || submitted) &&
              f.inception_date.errors?.required
            "
          >
            Cover from is required.
          </div>
          <mat-error
            class="invalid-feedback"
            *ngIf="f.inception_date.hasError('matDatepickerMin') && submitted"
            >Please select the valid date.</mat-error
          >
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group w-100">
          <input
            type="text"
            required
            name="cover_to"
            formControlName="cover_to"
            placeholder="Cover To"
            class="form-control form-control-sm datepicker"
            matInput
            (focus)="coverToDatepicker.open()"
            [matDatepicker]="coverToDatepicker"
            [disabled]="quote_type == 3"
            [ngClass]="{
              'is-invalid':
                (f.cover_to.touched || submitted) && f.cover_to.errors?.required
            }"
          />
          <mat-datepicker-toggle
            [for]="coverToDatepicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #coverToDatepicker></mat-datepicker>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.cover_to.touched || submitted) && f.cover_to.errors?.required
            "
          >
            Cover to is required.
          </div>
        </div>
      </div>
      <div class="col-md-6" *ngIf="!isBroker">
        <label><u>Broker Details</u></label>
        <mat-form-field style="width: 93%">
          <mat-select
            formControlName="company_id"
            class="form-control form-control-sm"
            name="company_id"
            (selectionChange)="getBrokerCommission($event)"
            [ngClass]="{
              'is-invalid':
                (f.company_id.touched || submitted) &&
                f.company_id.errors?.required
            }"
          >
            <mat-option [value]="">Select Broker</mat-option>
            <mat-option *ngFor="let brk of brokers" [value]="brk.id">
              {{ brk.name }}
            </mat-option>
          </mat-select>
          <div
            *ngIf="
              (f.company_id.touched || submitted) &&
              f.company_id.errors?.required
            "
            class="invalid-feedback"
          >
            Please select a broker.
          </div>
        </mat-form-field>
      </div>
    </div>
    <div
      class="row"
      *ngIf="
        (this.modelObject && this.modelObject.type == 3) || quote_type == 3
      "
    >
      <div class="col-md-6">
        <div class="form-group w-100">
          <label>MTA Effective Date</label><br />
          <input
            type="text"
            required
            name="effective_date"
            formControlName="effective_date"
            placeholder="MTA Effective Date"
            class="form-control form-control-sm datepicker"
            matInput
            (focus)="effectiveDateDatepicker.open()"
            [matDatepicker]="effectiveDateDatepicker"
            [min]="minEffectiveDate"
            [max]="maxInceptionDate"
            [ngClass]="{
              'is-invalid':
                (f.effective_date.touched || submitted) &&
                f.effective_date.errors?.required
            }"
          />
          <mat-datepicker-toggle
            [for]="effectiveDateDatepicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #effectiveDateDatepicker></mat-datepicker>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.effective_date.touched || submitted) &&
              f.effective_date.errors?.required
            "
          >
            Effective date is required.
          </div>
          <mat-error
            class="invalid-feedback"
            *ngIf="f.effective_date.hasError('matDatepickerMin')"
            >Please select the valid date.</mat-error
          >
        </div>
      </div>
    </div>
  </div>

  <!-- Company Or Individual details -->
  <div class="form_sections" formGroupName="proposer">
    <h4><u>Company Details</u></h4>
    <p>Is the proposer a Company, an Individual or in Joint Names?</p>
    <mat-radio-group
      required
      class="row"
      aria-label="Select an option"
      name="proposer_type"
      formControlName="proposer_type"
      (change)="onProposerChange($event)"
    >
      <div class="col-md-4">
        <div class="quote_radio w-90">
          <mat-radio-button [value]="2">Company</mat-radio-button>
        </div>
      </div>
      <div class="col-md-4">
        <div class="quote_radio w-90">
          <mat-radio-button [value]="1">Individual</mat-radio-button>
        </div>
      </div>
      <div class="col-md-4">
        <div class="quote_radio w-90">
          <mat-radio-button [value]="3">Joint Names</mat-radio-button>
        </div>
      </div>
    </mat-radio-group>
    <div
      class="invalid-feedback"
      style="font-size: 13px"
      *ngIf="
        (proposerControls.proposer_type.touched || submitted) &&
        proposerControls.proposer_type.errors?.required
      "
    >
      Please select the proposer type.
    </div>

    <!-- Company Details  -->
    <div
      *ngIf="
        proposerControls.proposer_type.value === 2 ||
        proposerControls.proposer_type.value === 3
      "
    >
      <div *ngIf="proposerControls.proposer_type.value === 2">
        <h6 class="mt-3">Is this client a Micro-enterprise?</h6>
        <mat-radio-group
          class="row"
          aria-label="Select an option"
          name="is_micro_enterprise"
          formControlName="is_micro_enterprise"
          required
          autocomplete="off"
        >
          <div class="col-md-4">
            <div class="quote_radio w-90">
              <mat-radio-button [value]="true">Yes</mat-radio-button>
            </div>
          </div>
          <div class="col-md-4">
            <div class="quote_radio w-90">
              <mat-radio-button [value]="false">No</mat-radio-button>
            </div>
          </div>
        </mat-radio-group>
        <div
          class="invalid-feedback"
          style="font-size: 13px"
          *ngIf="
            (proposerControls.is_micro_enterprise.touched || submitted) &&
            proposerControls.is_micro_enterprise.errors?.required
          "
        >
          Please select the proposer type.
        </div>

        <h6 class="mt-3">Company Details</h6>
      </div>
      <h6 class="mt-3" *ngIf="proposerControls.proposer_type.value === 3">
        Joint Names
      </h6>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <input
              required
              type="text"
              name="company_name"
              placeholder="{{
                proposerControls.proposer_type.value === 3
                  ? 'Names'
                  : 'Company name'
              }}"
              class="form-control form-control-sm"
              formControlName="company_name"
              [ngClass]="{
                'is-invalid':
                  (proposerControls.company_name.touched || submitted) &&
                  proposerControls.company_name.errors?.required
              }"
            />
            <div
              class="invalid-feedback"
              *ngIf="
                (proposerControls.company_name.touched || submitted) &&
                proposerControls.company_name.errors?.required
              "
            >
              {{
                proposerControls.proposer_type.value === 3
                  ? "Names field"
                  : "Company name"
              }}
              is required.
            </div>
          </div>
        </div>
      </div>

      <div
        class="row"
        *ngIf="proposerControls.proposer_type.value === 2"
      >
        <div class="col-md-6">

        </div>
      </div>
    </div>
    <!------------- COMPANY DETAILS END ------------------>

    <!------------- INDIVIDUAL PERSONAL DETAILS  ------------------>
    <div
      class="mt-3"
      *ngIf="proposerControls.proposer_type.value === 1"
    >
      <h6>Individual Details</h6>
      <div class="row">
        <div class="col-md-4" *ngIf="staticData">
          <!-- Title -->
          <mat-form-field class="w-100">
            <mat-label>Title</mat-label>
            <mat-select
              formControlName="title"
              class="form-control form-control-sm"
              name="title"
              required
              [ngClass]="{
                'is-invalid':
                  (proposerControls.title.touched || submitted) &&
                  proposerControls.title.errors?.required
              }"
            >
              <mat-option
                *ngFor="let title of staticData.title_options"
                [value]="title"
              >
                {{ title }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div
            class="invalid-feedback"
            *ngIf="
              (proposerControls.title.touched || submitted) &&
              proposerControls.title.errors?.required
            "
          >
            Title is required.
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group mt-1">
            <input
              type="text"
              name="first_name"
              placeholder="First Name"
              class="form-control form-control-sm"
              formControlName="first_name"
              required
              [ngClass]="{
                'is-invalid':
                  (proposerControls.first_name.touched || submitted) &&
                  proposerControls.first_name.errors?.required
              }"
            />
            <div
              class="invalid-feedback"
              *ngIf="
                (proposerControls.first_name.touched || submitted) &&
                proposerControls.first_name.errors?.required
              "
            >
              First name is required.
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <input
              type="text"
              name="last_name"
              placeholder="Last Name"
              class="form-control form-control-sm"
              formControlName="last_name"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group w-100 mt-2">
            <input
              type="text"
              required
              name="dob"
              formControlName="dob"
              placeholder="Date Of Birth"
              class="form-control form-control-sm datepicker"
              matInput
              (focus)="dobDatepicker.open()"
              [matDatepicker]="dobDatepicker"
              [max]="maxDob"
              [ngClass]="{
                'is-invalid':
                  (proposerControls.dob.touched || submitted) &&
                  proposerControls.dob.errors?.required
              }"
            />
            <mat-datepicker-toggle
              [for]="dobDatepicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #dobDatepicker></mat-datepicker>
            <div
              class="invalid-feedback"
              *ngIf="
                (proposerControls.dob.touched || submitted) &&
                proposerControls.dob.errors?.required
              "
            >
              DOB is required.
            </div>
          </div>
        </div>
      </div>
    </div>

    <!------------------ CONTACT DETAILS ------------------->
    <div class="form_sections">
      <h6>Contact details</h6>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <input
              matInput
              required
              type="email"
              name="email"
              formControlName="email"
              placeholder="Email"
              class="form-control form-control-sm"
              [ngClass]="{
                'is-invalid':
                  (proposerControls.email.touched || submitted) &&
                  proposerControls.email.errors?.required
              }"
            />
            <div
              class="invalid-feedback"
              *ngIf="
                (proposerControls.email.touched || submitted) &&
                proposerControls.email.errors?.required
              "
            >
              Please enter your email address.
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <input
              type="text"
              required
              name="phone"
              formControlName="phone"
              placeholder="Phone"
              class="form-control form-control-sm"
              matInput
              [ngClass]="{
                'is-invalid':
                  (proposerControls.phone.touched || submitted) &&
                  proposerControls.phone.errors?.required
              }"
            />
            <div
              class="invalid-feedback"
              *ngIf="
                (proposerControls.phone.touched || submitted) &&
                proposerControls.phone.errors?.required
              "
            >
              Please enter your phone number.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="proposerControls.proposer_type.value">
      <h6 class="mt-3">Correspondence Address</h6>
      <div formGroupName="address">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <input
                type="text"
                name="postcode"
                placeholder="Postcode"
                class="form-control form-control-sm"
                (keyup)="postcodeLookup($event)"
                pattern="^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$"
                formControlName="postcode"
                [ngClass]="{
                  'is-invalid': proposerAddressControls.postcode.invalid
                }"
                [matAutocomplete]="auto"
                appUpperCase
              />
              <div
                *ngIf="proposerAddressControls.postcode.errors?.pattern"
                class="invalid-feedback"
              >
                Invalid postcode.
              </div>
              <div
                class="invalid-feedback"
                *ngIf="
                  (proposerAddressControls.postcode.touched || submitted) &&
                  proposerAddressControls.postcode.errors?.required
                "
              >
                Please enter the postcode.
              </div>
              <div>
                <mat-autocomplete #auto="matAutocomplete">
                    <mat-option
                      [value]="proposerAddressControls.postcode.value" 
                      (click)="onSelectAddress(adrs)"
                      *ngFor="let adrs of addresses"
                    >
                      {{ adrs.l || (adrs.formatted_address ? adrs.formatted_address.join(', ') : '') }}
                    </mat-option>
                </mat-autocomplete>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <input
                type="text"
                name="address1"
                placeholder="Address Line 1"
                class="form-control form-control-sm"
                formControlName="address1"
                required
                [ngClass]="{
                  'is-invalid':
                    (proposerAddressControls.address1.touched || submitted) &&
                    proposerAddressControls.address1.errors?.required
                }"
              />
              <div
                class="invalid-feedback"
                *ngIf="
                  (proposerAddressControls.address1.touched || submitted) &&
                  proposerAddressControls.address1.errors?.required
                "
              >
                Please enter the address line 1.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <input
                type="text"
                name="address2"
                placeholder="Address Line 2"
                class="form-control form-control-sm"
                formControlName="address2"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <input
                type="text"
                name="address3"
                placeholder="Address Line 3"
                class="form-control form-control-sm"
                formControlName="address3"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <input
                type="text"
                name="county"
                placeholder="County"
                class="form-control form-control-sm"
                formControlName="county"
                required
                [ngClass]="{
                  'is-invalid':
                    (proposerAddressControls.county.touched || submitted) &&
                    proposerAddressControls.county.errors?.required
                }"
              />
              <div
                class="invalid-feedback"
                *ngIf="
                  (proposerAddressControls.county.touched || submitted) &&
                  proposerAddressControls.county.errors?.required
                "
              >
                Please enter the county.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!------------- CONVICTIONS  ------------------>
  </div>
  <!-- Controls -->
  <div class="row">
    <div class="col-md-6"></div>
    <div class="col-md-6 text-right">
      <button class="btn btn-success btn-sm">Proceed</button>
    </div>
  </div>
</form>
